import type { ReactNode } from 'react';
import { PharmacyCeOverviewCard } from './PharmacyCeOverviewCard';
import { PharmacyOpenIssuesCard } from './PharmacyOpenIssuesCard';
import { PharmacyTrackerHealthCard } from './PharmacyTrackerHealthCard';
import type {
  PatientTrackingDashboardCardId,
  PatientTrackingDashboardSummary
} from './patientTrackingDashboardTypes';

export interface PatientTrackingDashboardCardLinks {
  trackerHref: string;
  coveredEntityHref: string;
}

export function renderPatientTrackingDashboardCard(
  id: PatientTrackingDashboardCardId,
  summary: PatientTrackingDashboardSummary,
  links: PatientTrackingDashboardCardLinks
): ReactNode {
  if (id === 'pharmacyOpenIssues') {
    return <PharmacyOpenIssuesCard summary={summary} openHref={links.trackerHref} />;
  }
  if (id === 'pharmacyTrackerHealth') {
    return <PharmacyTrackerHealthCard summary={summary} openHref={links.trackerHref} />;
  }
  if (id === 'pharmacyCeOverview') {
    return <PharmacyCeOverviewCard summary={summary} openHref={links.coveredEntityHref} />;
  }
  return null;
}
